import React from 'react';
import { FiChevronLeft } from 'react-icons/fi';
import { DashboardSidebar } from '@/layouts/dashboard';
import { Link } from 'react-router-dom';
import { t } from 'i18next';
import { StepperWrapper } from '@/components/custom/stepper';
import { ButtonBack, ButtonBackContent } from '@/components/ui/button';
import { IconWrapper } from '@/components/custom/icon';
import { FilterTitle } from '@/components/custom/filter';

export default function ActivitySidebar(props) {
  const { steps, currentStep, courseId, moduleId } = props;

  return (
    <DashboardSidebar
      hasBrand={false}
      viewMode="create"
    >
      <ButtonBack asChild>
        <Link to={`/curso/admin/gerenciar/${courseId}/${moduleId}/atividades/d`}>
          <IconWrapper>
            <FiChevronLeft />
          </IconWrapper>
          <ButtonBackContent>
            <FilterTitle>{t('textsCommon.activities')}</FilterTitle>
          </ButtonBackContent>
        </Link>
      </ButtonBack>

      <StepperWrapper
        steps={steps}
        currentStep={currentStep}
      />
    </DashboardSidebar>
  );
}
